module.exports = {
  merchantName: "Hikaru Sushi",
  merchantDomain: "https://hikarusushirameninchicore.com", // Need correct！ project will upload dist to targer domain file in Plesk.
  merchantMenuUrl: "/menu-hikaru-sushi-ramen-restaurant-inchicore", // target merchant's menu url in alleatapp.com
  // when you building files, fill this info, dont push these to github.
  pleskUsername: "root",
  pleskPs: "D03BQ3Hb",
};
